import { render, staticRenderFns } from "./Wp_home_actives_model.vue?vue&type=template&id=47394adf&scoped=true&"
import script from "./Wp_home_actives_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_actives_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47394adf",
  null
  
)

export default component.exports